module.exports = __webpack_public_path__ + "img/门户设计.b0832d7d.png";